<!--
 * @Author: Zheng Lei
 * @Email: baimoc@163.com
 * @Date: 2021-03-03 10:49:23
 * @LastEditTime: 2021-06-24 10:10:26
 * @FilePath: \EmAtlas\src\views\Analysis\GenomeAnalysis.vue
-->
<template>
    <div class="baimo-scrollbar no-selected">
        <div style="height: 30px; color: #2F363D; background: #F6F8FA;border-top: 1px solid #E1E4E8;border-bottom: 1px solid #E1E4E8">
            <div style="height: 30px; color: #2F363D; background: #F6F8FA; padding: 6px 10px 0px 10px;white-space:nowrap;overflow:hidden;">
                <span style="">Structure Viewer</span>
                <i class="el-icon-question bm-btn" style="float: right;font-size: 18px;padding-right: 5px;"></i>
                <i class="el-icon-download bm-btn" @click="download_structure"
                   style="float: right;font-size: 18px;padding-right: 5px;"></i>
                <!--<i class="el-icon-video-camera-solid bm-btn" @click="animation_btn" style="float: right;font-size: 18px;padding-right: 5px;"></i>-->
                <!--<i class="el-icon-rank bm-btn" style="float: right;font-size: 18px;padding-right: 5px;"></i>-->
                <i class="el-icon-refresh-left bm-btn" @click="refresh"
                   style="float: right;font-size: 18px;padding-right: 5px;"></i>
            </div>
        </div>

        <div v-loading="loading" id="cotainer1"
             :style="{height: height, width: width, background: 'white', float:'right'}">
            <!--<div style="float:right;">-->
            <!--<el-button icon="el-icon-question" circle></el-button>-->
            <!--<el-button icon="el-icon-download" circle></el-button>-->
            <!--</div>-->
        </div>
    </div>
</template>

<script>
    export default {
        name: "StructureView",
        data() {
            return {
                winHeight: window.innerHeight - 50 - 595 + "px",
                winWidth: window.innerWidth - 360 - 360 + "px",
                current_stage: '',
                current_NGL: '',
                src: "",
                timer: "",
                timer2: "",
                loading: false,
                seletedRepr: '',
                seletedReprRaw: '',
                raac_color8: {},
                protein_pdb: "",
                aa_map: {
                    'G': 'Gly',
                    'A': 'Ala',
                    'S': 'Ser',
                    'P': 'Pro',
                    'V': 'Val',
                    'T': 'Thr',
                    'C': 'Cys',
                    'L': 'Leu',
                    'I': 'Ile',
                    'N': 'Asn',
                    'D': 'Asp',
                    'Q': 'Gln',
                    'K': 'Lys',
                    'E': 'Glu',
                    'M': 'Met',
                    'H': 'His',
                    'F': 'Phe',
                    'R': 'Arg',
                    'Y': 'Tyr',
                    'W': 'Trp'
                },
                structure_global_setting: {},
                structure_selection_setting: {},
                structure_surface_setting: {},
                surfaceRepr: null,
                pdb_url: '',
                accession: '',
                raac_color: '',
                raac_scheme: '',
                is_init: true,
            }
        },
        mounted() {
            // this.init();
            window.addEventListener('resize', this.resize, true)
        },
        watch: {
            protein_pdb() {
                // console.log(val);
            },
            '$store.state.selected_range'(val) {
                this.selectedRange = val;
                if (!this.is_init) this.render_update('surface');
            },
            '$store.state.raac_color'(val) {
                this.raac_color = val;
                if (!this.is_init) this.render_update('surface');
            },
            '$store.state.raac_scheme'(val) {
                this.raac_scheme = val;
            },
            '$store.state.raac_shape'() {
                if (!this.is_init) this.render_update('surface');
            },
            '$store.state.raac_visible'() {
                if (!this.is_init) this.render_update('surface');
            },
            '$store.state.structure_global_setting'(val) {
                this.structure_global_setting = val;
                if (!this.is_init) this.render_update('surface');
                let canvas = document.querySelector('canvas');
                let global_background = this.structure_global_setting['background'];
                if (canvas !== null)
                    canvas.style['background-color'] = global_background;
            },
            '$store.state.structure_selection_setting'(val) {
                this.structure_selection_setting = val;
                if (!this.is_init) this.render_update('surface');
            },
            '$store.state.structure_surface_setting'(val) {
                this.structure_surface_setting = val;
                if (!this.is_init) this.render_update("surface");
            },
            '$store.state.structure_resize'() {
                this.resize();
            },
            '$store.state.current_protein'(val) {
                // console.log("current_protein", val);
                this.pdb_url = this.$store.state.current_protein['pdb_url'];
                // console.log("this.pdb_url", this.pdb_url)
                this.accession = this.$store.state.current_protein['accession'];
                this.init();
                // try {
                //     window.stage.removeAllComponents();
                // } catch (e) {
                //     e
                // }
                // this.process();
            },
        },
        props: {
            height: String,
            width: String,
        },
        methods: {
            init() {
                // let url = this.$store.state.current_protein['pdb_url'];
                // let vue_obj = this;
                // console.log("url", url);
                this.structure_surface_setting = this.$store.state.structure_surface_setting;
                this.structure_global_setting = this.$store.state.structure_global_setting
                this.timer = setInterval(this.get_stage, 1000);
            },
            get_stage() {
                // console.log("get_stage");
                this.loading = true;
                if (window.stage === undefined || window.stage === "" || window.stage === " ") {
                    window.stage
                } else {
                    // console.log("window.stage", window.stage, Object.keys(window.stage).length, Object.keys(window.stage));
                    this.current_stage = window.stage;
                    this.current_NGL = window.NGL;
                    window.addEventListener("resize", function () {
                        window.stage.handleResize();
                    }, false);
                    // console.log("window.stage", this.current_stage);
                    this.process();
                    // this.timer2 = setInterval(this.process, 2000);
                    clearInterval(this.timer);
                }
            },
            process() {
                let doc = document.getElementsByTagName("canvas");
                if (doc.length > 0) {
                    this.loading = true;
                    let url = this.$store.state.current_protein['pdb_url'];
                    let vue_obj = this;
                    // console.log("url", url);
                    window.stage.loadFile(url).then(function (component) {
                        // component.addRepresentation("cartoon");
                        // console.log("loadFile >>>>>>>>>>>>>>>");
                        vue_obj.loading = false;
                        vue_obj.component = component;
                        vue_obj.seletedReprRaw = component;
                        // console.log("vue_obj.seletedReprRaw", vue_obj.seletedReprRaw);
                        vue_obj.render_update("init");
                        vue_obj.loading = false;
                        clearInterval(vue_obj.timer2);
                    });
                    this.tooltip();
                } else {
                    let url = this.$store.state.current_protein['pdb_url'];
                    // console.log("url", url);
                    // this.refresh();
                }
                // console.log("process >>>>>>>>>>>>>>>", this.$store.state.current_protein);
                // console.log(doc, doc.length);

                // } catch (e) {
                //     this.refresh();
                //     console.log("error", window.stage)
                // }
            },
            refresh() {
                this.loading = true;
                window.location.reload()
            },
            resize() {
                window.stage.handleResize();
            },
            download_structure() {
                let file_name = this.accession + "_" + this.$route.params.jobid;
                var canvas = document.querySelector('canvas');
                var a = document.createElement('a');
                a.href = canvas.toDataURL('image/png');
                a.download = file_name;
                a.click();
            },
            selected_update() {
                // console.log("selected_update", this.selectedRange)
                if (this.selectedRange !== null && this.selectedRange !== undefined) {
                    let start = this.selectedRange['start'];
                    let end = this.selectedRange['end'];

                    let repr = this.structure_selection_setting['representation'];
                    let selected_color = this.structure_selection_setting['color'];
                    let setting = {sele: `${start}-${end}`};
                    if (this.selectedRange['shape'] === 'point') {
                        setting = {sele: `${start}, ${end}`};
                    }
                    // this.seletedReprRaw.addRepresentation("licorice", { sele: `${start}-${end}` });
                    if (selected_color === "" || selected_color === null) {
                        delete setting['color'];
                    } else {
                        setting['color'] = selected_color;
                    }
                    let selected_effect = this.structure_selection_setting['effect'];
                    let selected_focus = this.structure_selection_setting['focus'];
                    if (selected_effect === "Double" || selected_effect === "Current selected representation") {
                        this.seletedReprRaw.addRepresentation(repr, setting);
                    }

                    if (selected_focus) {
                        this.seletedReprRaw.autoView(`${start}-${end}`, 1000);
                    }

                }
            },
            render_update(composition) {
                // let color = this.$store.state.raac_color;
                let shape = this.$store.state.raac_shape;
                let visible = this.$store.state.raac_visible;
                let scheme = this.$store.state.raac_scheme;
                let color_scheme = this.get_scheme();

                let sele = {};
                for (let i = 0; i < scheme.length; i++) {
                    let cur_scheme = scheme[i];
                    let cur_shape = shape[i];
                    let cur_visible = visible[i];
                    // console.log(cur_scheme);
                    if (typeof (sele[cur_shape]) != 'object') {
                        sele[cur_shape] = [];
                    }
                    if (cur_visible) {
                        for (let j = 0; j < cur_scheme.length; j++) {
                            let scheme_aa = cur_scheme[j];
                            sele[cur_shape].push2(this.aa_map[scheme_aa])
                        }
                    }
                }

                // try {
                // console.log("this.seletedReprRaw", this.seletedReprRaw);
                this.seletedReprRaw.removeAllRepresentations();
                for (let cur_shape in sele) {
                    // console.log(cur_shape, sele[cur_shape]);
                    let cur_sele = sele[cur_shape].join(" or ");
                    // console.log("cur_sele", cur_sele);
                    this.seletedReprRaw.addRepresentation(cur_shape, {sele: '0', colorScheme: color_scheme});
                    this.seletedReprRaw.addRepresentation(cur_shape, {sele: cur_sele, colorScheme: color_scheme});
                    // console.log("cur_sele", cur_sele);
                }

                // this.seletedReprRaw.removeAllRepresentations();
                // this.seletedReprRaw.addRepresentation("line", {colorScheme: color_scheme});

                if (composition === "surface" || composition === "init") {
                    if (this.structure_surface_setting['surface_visual']) {
                        let setting = {
                            surfaceType: this.structure_surface_setting['surface_type'], // 'vws', 'sas', 'ms' and 'sas', 'av' https://github.com/nglviewer/ngl/issues/655
                            opacity: this.structure_surface_setting['surface_opacity'], // 0-1,0.01
                            contour: this.structure_surface_setting['surface_contour'],
                            side: this.structure_surface_setting['surface_side'].toLowerCase(),
                            smooth: this.structure_surface_setting['surface_smooth'],
                            roughness: this.structure_surface_setting['surface_roughness'], //0-1,0.01
                            metalness: this.structure_surface_setting['surface_metalness'], //0-1,0.01
                            probeRadius: this.structure_surface_setting['surface_probe_radius'], // 0- 20,1
                            scaleFactor: this.structure_surface_setting['surface_scale_factor'], // 0-5,1
                            flatShaded: this.structure_surface_setting['surface_flat_shaded'],
                            colorScheme: color_scheme,
                        };
                        let surface_color = this.structure_surface_setting['surface_color'];
                        if (surface_color === "" || surface_color === null) {
                            delete setting['color'];
                        } else {
                            setting['color'] = surface_color;
                        }

                        // 选区渲染 -----------------------------------------------------------------------------
                        let selected_effect = this.structure_selection_setting['effect'];
                        // console.log("selected_effect", selected_effect, this.selectedRange);
                        if (selected_effect === "Double" || selected_effect === "Surface") {
                            if (this.selectedRange !== null && this.selectedRange !== undefined) {
                                let start = this.selectedRange['start'];
                                let end = this.selectedRange['end'];
                                let selected_color = this.structure_selection_setting['color'];
                                setting['sele'] = `not ${start}-${end}`;
                                if (this.selectedRange['shape'] === 'point') {
                                    setting['sele'] = `not ${start} and not ${end}`;
                                }
                                this.surfaceRepr = this.seletedReprRaw.addRepresentation("surface", setting);

                                setting['sele'] = `${start}-${end}`;
                                if (this.selectedRange['shape'] === 'point') {
                                    setting['sele'] = `${start}, ${end}`;
                                }
                                setting['color'] = selected_color;
                                if (this.selectedRange['color'] !== undefined) {
                                    setting['color'] = this.selectedRange['color'];
                                }
                                this.seletedReprRaw.addRepresentation("surface", setting);
                            } else {
                                this.surfaceRepr = this.seletedReprRaw.addRepresentation("surface", setting);
                            }
                        } else if (selected_effect === "Current selected representation") {
                            this.surfaceRepr = this.seletedReprRaw.addRepresentation("surface", setting);
                        }

                    }
                }
                this.selected_update();
                let animation = this.structure_global_setting['animation'];
                let focus = this.structure_global_setting['focus'];
                window.stage.setSpin(animation);
                // -------------------------------------
                if (composition === "refresh" || composition === "init" || focus) {
                    this.seletedReprRaw.autoView(1000);
                }

                // } catch (e) {
                //     console.log("error")
                // }
                // this.current_stage.setParameters({
                //     backgroundColor: this.structure_global_setting['backgound']
                // });
                this.is_init = false;
            },


            get_scheme() {
                let raac_scheme = this.get_raac_scheme()
                // try {
                let schemeId = this.current_NGL.ColormakerRegistry.addScheme(function () {
                    this.atomColor = function (atom) {
                        return raac_scheme[atom.resname]
                    };
                });
                return schemeId
                // } catch (e) {
                //     e
                // }
            },
            get_raac_scheme() {
                let aa_map = {
                    'G': 'GLY',
                    'A': 'ALA',
                    'S': 'SER',
                    'P': 'PRO',
                    'V': 'VAL',
                    'T': 'THR',
                    'C': 'CYS',
                    'L': 'LEU',
                    'I': 'ILE',
                    'N': 'ASN',
                    'D': 'ASP',
                    'Q': 'GLN',
                    'K': 'LYS',
                    'E': 'GLU',
                    'M': 'MET',
                    'H': 'HIS',
                    'F': 'PHE',
                    'R': 'ARG',
                    'Y': 'TYR',
                    'W': 'TRP'
                };
                let res = {};
                // let raacs = input.raac.split("-");
                // let colors = input.color.split(",");
                let raacs = this.$store.state.raac_scheme;
                let colors = this.$store.state.raac_color;
                // console.log(raacs,colors);
                for (let i = 0; i < raacs.length; i++) {
                    let group = raacs[i];
                    let group_color = colors[i].replace("#", "0x");
                    for (let j = 0; j < group.length; j++) {
                        let aa_name = aa_map[group[j]];
                        this.raac_color8[aa_name] = colors[i];
                        // console.log(group_color, typeof (group_color.toString(16)))
                        res[aa_name] = parseInt(group_color, 16);
                    }
                }
                return res
            },
            onClick() {
                window.stage.mouseControls.remove("hoverPick");
                window.stage.signals.clicked.add(function (pickingProxy) {
                    // console.log(pickingProxy)
                    let atom = pickingProxy.atom || pickingProxy.closestBondAtom;
                    let atom_name = atom.qualifiedName();
                    let resname = atom.resname;
                    // console.log(atom_name, resname)
                });
            },
            tooltip() {
                let tooltip = document.createElement("div");
                Object.assign(tooltip.style, {
                    display: "none",
                    position: "fixed",
                    zIndex: 10,
                    pointerEvents: "none",
                    backgroundColor: "rgba( 0, 0, 0, 0.6 )",
                    color: "lightgrey",
                    padding: "8px",
                    fontFamily: "sans-serif"
                });
                document.body.appendChild(tooltip);
                let raac_color8 = this.raac_color8;
                window.stage.mouseControls.remove("hoverPick");
                window.stage.signals.hovered.add(function (pickingProxy) {
                    if (pickingProxy && (pickingProxy.atom || pickingProxy.bond)) {
                        let atom = pickingProxy.atom || pickingProxy.closestBondAtom;
                        let atom_name = atom.qualifiedName();
                        let resname = atom.resname;
                        let current_color = raac_color8[resname];
                        tooltip.innerHTML = `<i class='iconfont icon-yuan tooltip-circle' style="color:${current_color}"></i>  ${resname}<br/>${atom_name}`;
                        let mp = pickingProxy.mouse.position;
                        tooltip.style.bottom = window.innerHeight - mp.y + 3 + "px";
                        tooltip.style.left = mp.x + 3 + "px";
                        tooltip.style.display = "block";
                        Object.assign(tooltip.style, {
                            position: "absolute",
                            zIndex: 10,
                            pointerEvents: "none",
                            backgroundColor: "white",
                            color: "rgb(102, 102, 102)",
                            padding: "0.5em",
                            fontFamily: "sans-serif",
                            borderRadius: '4px',
                            borderWidth: '1px',
                            boxShadow: "rgb(0 0 0 / 20%) 1px 2px 10px",
                            transition: "opacity 0.2s cubic-bezier(0.23, 1, 0.32, 1) 0s, visibility 0.2s cubic-bezier(0.23, 1, 0.32, 1) 0s, transform 0.4s cubic-bezier(0.23, 1, 0.32, 1) 0s",
                        });
                    } else {
                        tooltip.style.display = "none";
                    }
                });
            },
        }

    }

    Array.prototype.push2 = function () {
        for (var i = 0; i < arguments.length; i++) {
            var ele = arguments[i];
            if (this.indexOf(ele) == -1) {
                this.push(ele);
            }
        }
    };


</script>

<style scoped>
    .baimo-scrollbar {
        overflow: hidden;
    }

    .topright-icon {
        float: right;
        left: 10px;
        top: 10px;
    }

    .bm-btn {
        cursor: pointer;
    }
</style>
